<template>
  <div class="sidebar-logo-container pt12" :class="{'collapse':collapse}" style="background-color: #fff;" @click="jumpPageHome">
    <transition name="sidebarLogoFade" >
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/" style="display: flex;align-items: center;">
        <img :src="logoOnest" class="sidebar-logo ml12" style="width: 38px;">
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/" style="display: flex;align-items: center;">
        <img :src="logo" class="sidebar-logo dib ml18">
        <!-- <h1 class="sidebar-title" >{{ title }} </h1> -->
      </router-link>
    </transition>
  </div>
</template>

<script>
import logoImg from '@/assets/kaneng/logo.jpg'
import logoOnest from '@/assets/kaneng/logoOnest.png'
import variables from '@/assets/styles/variables.scss'
import { session } from "@/utils/session";

export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    variables() {
      return variables;
    },
	sideTheme() {
      return this.$store.state.settings.sideTheme
    }
  },
  data() {
    return {
      title: '',
      logo: logoImg,
      logoOnest: logoOnest
    }
  },
  mounted(){
    this.title = session.getVillageName();
    console.log('');
  },
  methods: {
    jumpPageHome() {
      // this.$router.push({path:'homePage'})
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 55px;
  // line-height: 50px;
  background: #2b2f3a;
  // text-align: center;
  // padding-left: 18px;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 168px;
      // height: 17px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      // color: #fff;
      width: 125px;
      text-align: center;
      font-weight: 600;
      // line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Logo.vue